(() => {
  angular
    .module('app.components')
    .directive('circleProgress', () => {
      return {
        restrict: 'E',
        scope: {
          value: '=',
          size: '@',
          color: '@',
          showNumber: '='
        },
        template: '<div class="circle-progress"><span ng-show="showNumber">{{valueNumber}}</span></div>',
        link: (scope, element) => {
          scope.valueNumber = 0;

          scope.$watch('value', value => {
            if (typeof value !== 'undefined') {
              init();
            }
          });

          function init() {
            let size = 0;
            let thickness = 2;
            const value = scope.value * 0.1;
            const el = $(element).find('div');

            switch(scope.size) {
              case 'small': size = 38; el.addClass('circle-progress--lg'); break;
              case 'medium': size = 44; el.addClass('circle-progress--md'); break;
              case 'large': size = 180; thickness = 4; el.addClass('circle-progress--lg'); break;
            }

            let gradientStart = '#aae823';
            let gradientEnd = '#9ee00f';
            let emptyFill = 'rgba(0,0,0,0.1)';
            let c = 'circle-progress--success';

            if (value < 0.8 && value > 0.5 ) {
              gradientStart = '#e9e348';
              gradientEnd = '#dfc61f';
              c = 'circle-progress--warning';
            } else if (value < 0.6 ) {
              gradientStart = '#ee7057';
              gradientEnd = '#ee5757';
              c = 'circle-progress--danger';
            }

            if (scope.color === 'light') {
              gradientStart = '#fff';
              gradientEnd = '#ddd';
              emptyFill = 'rgba(255,255,255, 0.25)';
              c = '';
            } else if (scope.color === 'dark') {
              gradientStart = '#000';
              gradientEnd = '#333';
              emptyFill = 'rgba(0,0,0, 0.25)';
              c = '';
            }

            el.circleProgress({
              size,
              value,
              emptyFill,
              thickness,
              startAngle: -Math.PI / 2,
              animation: { duration: 1000 },
              lineCap: 'round',
              fill: { gradient: [gradientStart, gradientEnd] }
            }).on('circle-animation-progress', (event, progress, stepValue) => {
              scope.$apply(() => {
                const value = Math.round((stepValue * 10) * 10) / 10;
                scope.valueNumber = Math.round(value * 10) / 10;
              });
            });

            el.addClass(c);
          }
        }
      };
    });
})();
